import { render, staticRenderFns } from "./Prospect.vue?vue&type=template&id=08057040&scoped=true&"
import script from "./Prospect.vue?vue&type=script&lang=js&"
export * from "./Prospect.vue?vue&type=script&lang=js&"
import style0 from "./Prospect.vue?vue&type=style&index=0&id=08057040&scoped=true&lang=css&"
import style1 from "./Prospect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08057040",
  null
  
)

export default component.exports